import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CountUp from 'react-countup';
import { CommonBadgeGenerate } from './commonBadge';
import Carousel from 'react-material-ui-carousel'
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },

    card: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: '10px',
        borderRadius: '10px',
        boxShadow: ' 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
        maxHeight: 300,
        height: 190,
        marginTop: 10
    },
    title: {
        fontSize: 15,
        color: "#229954"
    },
    titleMin: {
        fontSize: 20,
        alignContent: 'center'
    },
    titleSecondary: {
        fontSize: 15,
        alignContent: 'center'
    },
});


export const CheckRoleGtnGrnVariance = ({ data }) => {
    const classes = useStyles();
    return (

        <Card className={classes.card} boxShadow={3}>
            <CardContent>
                <CommonBadgeGenerate
                    cardTitle={
                        <div className={classes.title} color="textSecondary">
                            <b>Variance</b>
                        </div>
                    }
                    badgeName={"E"}
                />
                <Carousel indicatorContainerProps={{
                    style: {
                        marginTop: "40px"
                    }
                }}>
                    {
                        data.map((items, i) =>
                            <Grid container spacing={1}>
                                <Grid item xs={12} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>{items.collectionPointName}</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>Check Role</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>Factory</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>Variance</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleMin} color="textSecondary" component="h2">
                                        <CountUp decimals={2} end={items.netAmount} duration={3} />
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleMin} color="textSecondary" component="h2">
                                        <CountUp decimals={2} end={items.grnNet} duration={3} />
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography style={{
                                        borderRadius: '16px',
                                        backgroundColor: (parseFloat(items.grnNet) - parseFloat(items.netAmount)) == parseFloat(0) ? "#EDFD8C"
                                            : (items.grnNet - items.netAmount) > parseFloat(0) ? "#8FFD8C" : "#FD8167"
                                    }}
                                        className={classes.titleMin} color="textSecondary" gutterBottom>
                                        <CountUp decimals={2} end={items.grnNet - items.netAmount} duration={3} />
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>Field</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>Factory</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                                        <b>Variance</b>
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleMin} color="textSecondary" component="h2">
                                        <CountUp decimals={2} end={items.gtnNet} duration={3} />
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography className={classes.titleMin} color="textSecondary" component="h2">
                                        <CountUp decimals={2} end={items.grnNet} duration={3} />
                                    </Typography>
                                </Grid>
                                <Grid style={{ marginTop: '-10px' }} item xs={4} align="center">
                                    <Typography style={{
                                        borderRadius: '16px',
                                        backgroundColor: (parseFloat(items.grnNet) - parseFloat(items.gtnNet)) == parseFloat(0) ? "#EDFD8C"
                                            : (items.grnNet - items.gtnNet) > parseFloat(0) ? "#8FFD8C" : "#FD8167"
                                    }}
                                        className={classes.titleMin} color="textSecondary" gutterBottom>
                                        <CountUp decimals={2} end={items.grnNet - items.gtnNet} duration={3} />
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    }
                </Carousel>
            </CardContent>
        </Card>
    );
}